<template>
  <div>
    <section class="content">
      <v-row>
        <v-col cols="12" xs="12" md="12">
           <v-btn small @click.prevent="exportInfluencers">Export</v-btn>

            <!-- Reload button -->
            <v-btn color="secondary" small @click.stop="reloadAll()">
              Reload All
              <i class="fa fa-repeat"></i>
            </v-btn>

            <!-- Copy Link -->
            <v-tooltip 
              right
              :open-on-hover="false"
              v-model="linkCopied">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="copyLink(null)"
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  small
                >
                  <span style="color:#fff">Copy Travel Form</span>&nbsp;
                  <v-icon
                    v-on="on"
                    style="color:#fff"
                    small
                  >mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span><v-icon color="white darken-2">mdi-check-all</v-icon> Copied</span>
            </v-tooltip>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row align="center" style="margin:30px 0px 0px 0px;">
        <!-- <v-col cols="12" xs="12" md="1" lg="1" align="right">
          <div style="font-size:16px;font-weight:400;">Filters:</div>
        </v-col> -->
        <!-- <v-col cols="12" xs="12" md="2" lg="2">
          <v-select
            outlined
            hide-details="auto"
            :items="platformList"
            item-value="value"
            item-text="text"
            v-model="selectedPlatform"
            @change="paginate()"
          ></v-select>
        </v-col> -->
        <v-col cols="12" xs="12" md="3">
          <v-text-field
            outlined            
            label="Email, Handle, Fullname"
            v-model="igHandle"
            hide-details="auto"
            id="igHandle"
            @keyup.enter="paginate()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="3">         
          <v-combobox
            v-model="influencerGeos"
            :items="countries"
            hide-selected
            multiple            
            clearable
            small-chips
            outlined
            hide-details="auto"
            label="Influencer Location"
            @change="paginate()"                    
          >
            <template v-slot:selection="data">
              <v-chip :input-value="data.selected" close @click:close="remove(data.item)">
                <strong>{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="12" xs="12" md="3">
          <v-combobox
            v-model="infCategory"
            :items="infCategories"
            hide-selected
            multiple            
            clearable
            small-chips
            outlined
            hide-details="auto"
            label="Categories"               
          >
            <template v-slot:selection="data">
              <v-chip :input-value="data.selected" close @click:close="removeCategory(data.item)">
                <strong>{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="12" xs="12" md="2">
          <v-menu
            ref="monthPicker"
            v-model="monthPicker"
            :close-on-content-click="false"
            :return-value.sync="joinedMonth"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field                
                label="Joined Month"
                v-model="joinedMonth"                
                readonly    
                clearable            
                outlined
                hide-details="auto"
                v-bind="attrs"
                v-on="on"          
                @change="paginate()" 
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="joinedMonth"
              type="month"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="secondary"
                @click="monthPicker = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="secondary"
                @click="joinedMonthOk"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="12" class="pb-1">
          <div class="platform-filter" role="group" aria-label="Filter influencers by platform">
            <span class="platform-filter__label">Platforms</span>
            <v-btn
              v-for="platform in platformFilterOptions"
              :key="platform.filterKey"
              text
              small
              class="platform-filter__button"
              :class="{ 'platform-filter__button--active': searchFilter[platform.filterKey] }"
              :aria-pressed="String(searchFilter[platform.filterKey])"
              @click="togglePlatformFilter(platform.filterKey)"
            >
              <img
                v-if="platform.imgIcon"
                :src="platform.imgIcon"
                :alt="`${platform.text} logo`"
                class="platform-filter__logo"
              >
              <v-icon v-else left size="18" :color="platform.iconColor">
                {{ platform.icon }}
              </v-icon>
              <span>{{ platform.text }}</span>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" xs="12" md="1" lg="1" style="min-width:200px;max-width:200px">
          <v-checkbox
            class="pending-approval-checkbox mt-0"
            v-model="searchFilter.pendingApproval"
            label="Pending Approval"
            color="secondary"
            :value="false"
            hide-details
            @change="paginate()"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12" xs="12" md="12">
          <button
                id="viewCompany"
                style="display: none"
                data-toggle="modal"
                :data-target="viewCompanyModalIdDisplay"
              ></button>
              <button
                id="viewPosts"
                style="display: none"
                data-toggle="modal"
                :data-target="influencerPostDisplay"
              ></button>
              <v-data-table
                :headers="fields"
                :items="items"
                :loading="loading"
                :options.sync="pagination"
                :footer-props="{
                  itemsPerPageOptions: rowsPerPageItems
                }"
                :server-items-length="totalItems"
                item-key="_id"
                class="ims-sticky-actions-table actions-column-visible elevation-1"
              >
                <template v-slot:[`item.profilePicture`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <v-avatar :size="avatarSize" color="grey lighten-4">
                        <img v-bind:src="paserImageUrl(item.profilePicture)" alt="avatar" />
                      </v-avatar>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.igHandle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <div class="d-flex flex-row" v-if="item.igHandle">
                        <v-avatar :size="avatarSize" color="grey lighten-4" v-if="item.igHandle">
                          <img v-bind:src="paserImageUrl(item.igProfilePicture)" alt="avatar" />
                        </v-avatar>
                        <a
                          target="_blank"
                          v-bind:href="'https://instagram.com/' + item.igHandle"
                        ><v-icon color="#E4405F" small>mdi-instagram</v-icon> @{{ item.igHandle }}</a>
                        <!-- <v-tooltip 
                          right
                          :open-on-hover="false"
                          v-model="item.linkCopied">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="copyLink(item, item.igHandle, 'igHandle')"
                              v-bind="attrs"
                              v-on="on"
                              text
                              small
                            >
                              <v-icon small>mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip> -->
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.tiktokHandle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <div class="d-flex flex-row" v-if="item.tiktokHandle">
                        <v-avatar :size="avatarSize" color="grey lighten-4" v-if="item.tiktokHandle">
                          <img v-bind:src="paserImageUrl(item.tiktokProfilePicture)" alt="avatar" />
                        </v-avatar>
                        <a
                          target="_blank"
                          v-bind:href="'https://www.tiktok.com/@' + item.tiktokHandle"
                          v-if="item.tiktokHandle"
                        ><img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.tiktokHandle }}</a>
                        <!-- <v-tooltip 
                          right
                          :open-on-hover="false"
                          v-model="item.linkCopied">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="copyLink(item, item.tiktokHandle, 'tiktokHandle')"
                              v-bind="attrs"
                              v-on="on"
                              text
                              small
                            >
                              <v-icon small>mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <span><v-icon color="white darken-2">mdi-check-all</v-icon> Copied</span>
                        </v-tooltip> -->
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.youtubeHandle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <v-avatar :size="avatarSize" color="grey lighten-4" v-if="item.youtubeHandle">
                        <img v-bind:src="paserImageUrl(item.youtubeProfilePicture)" alt="avatar" />
                      </v-avatar>
                      <a
                        :href="'https://youtube.com/@' + item.youtubeHandle"
                        target="_blank"
                        v-if="item.youtubeHandle"
                      ><v-icon>mdi-youtube</v-icon> @{{item.youtubeHandle}}</a>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.fbHandle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <v-avatar :size="avatarSize" color="grey lighten-4" v-if="item.fbHandle">
                        <img v-bind:src="paserImageUrl(item.fbProfilePicture)" alt="avatar" />
                      </v-avatar>
                      <a
                        :href="'https://www.facebook.com/' + item.fbHandle"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="item.fbHandle"
                      ><v-icon color="#1877F2" small>mdi-facebook</v-icon> @{{item.fbHandle}}</a>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.xhsHandle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <v-avatar :size="avatarSize" color="grey lighten-4" v-if="item.xhsHandle">
                        <img v-bind:src="paserImageUrl(item.xhsProfilePicture)" alt="avatar" />
                      </v-avatar>
                      <a
                        :href="'https://www.xiaohongshu.com/user/profile/' + item.xhsID"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="item.xhsHandle"
                      ><img
                        src="/static/img/xhs-black.png"
                        width="18px"
                        alt=""
                        aria-hidden="true"
                      > @{{item.xhsFullname}}</a>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.linkedinHandle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <v-avatar :size="avatarSize" color="grey lighten-4" v-if="item.linkedinHandle">
                        <img v-bind:src="paserImageUrl(item.linkedinProfilePicture)" alt="avatar" />
                      </v-avatar>
                      <a
                        :href="'https://www.linkedin.com/in/' + item.linkedinHandle"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="item.linkedinHandle"
                      ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{item.linkedinHandle}}</a>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.twitterHandle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <a
                        :href="'https://x.com/' + item.twitterHandle"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="item.twitterHandle"
                      ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true" /> @{{item.twitterHandle}}</a>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.handle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <a
                        target="_blank"
                        v-bind:href="'https://www.tiktok.com/@' + item.handle"
                        v-if="item.platform === 'tiktok'"
                      ><img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.handle }}</a>
                      <a
                        :href="'https://youtube.com/' + item.handle"
                        target="_blank"
                        v-else-if="item.platform === 'youtube'"
                      ><v-icon>mdi-youtube</v-icon> @{{item.handle}}</a>
                      <a
                        target="_blank"
                        v-bind:href="'https://instagram.com/' + item.handle"
                        v-else
                      ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.handle }}</a>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.joinedAt`]="{ item }">
                  <tr>
                    <td class="text-xs-left">{{ formatDateTime(item.joinedAt) }}</td>
                  </tr>
                </template>
                <template v-slot:[`item.lastLoginAt`]="{ item }">
                  <tr>
                    <td class="text-xs-left" v-show="item.lastLoginAt">{{ formatDateTime(item.lastLoginAt) }}</td>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr @click="props.expanded = !props.expanded">
                    <td class="text-xs-left">{{ props.item.totalFollowers }}</td>
                    <td class="text-xs-left">{{ props.item.engagementRate }}%</td>
                    <td class="text-xs-left">{{ props.item.audienceCredibility }}%</td>
                    <td class="text-xs-left">{{ formatDateTime(props.item.joinedAt) }}</td>
                  </tr>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <tr>
                    <td class="justify-center layout px-0">
                      <!-- <v-btn
                      @click="showReport(item, 'instagram')"
                      color="info"
                      class="ims-action" 
                      v-if="item.igHandle">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <i class="fab fa-instagram" v-on="on"></i>
                          </template>
                        </v-tooltip>
                      </v-btn> -->
                      <!-- View Influencer data -->
                      <v-btn
                        v-if="buttonShow('view')"
                        @click="getInfluencerDataToView(item.id, item)"
                        color="success"
                        class="ims-action"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-account-edit</v-icon>
                          </template>
                          <span>View Influencer</span>
                        </v-tooltip>
                      </v-btn>
                      <!-- Edit Influencer data -->
                      <!-- <v-btn
                        @click="getInfluencerDataToEdit(item.id)"
                        color="warning"
                        class="ims-action"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">edit</v-icon>
                          </template>
                          <span>Edit Influencer Detail</span>
                        </v-tooltip>
                      </v-btn> -->
                      <!-- Assign Platform -->
                      <v-btn
                        @click="getPlatformDataToView(item)"
                        color="primary"
                        class="ims-action text--secondary"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                            >mdi-account-group</v-icon>
                          </template>
                          <span>Assign Platform</span>
                        </v-tooltip>
                      </v-btn>
                      <!-- Delete User -->
                      <v-btn
                        @click="deleteInfluencer(item.id)"
                        color="red"
                        class="ims-action"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              style="color:#fff"
                            >mdi-delete</v-icon>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </v-btn>
                      <v-tooltip 
                        right
                        :open-on-hover="false"
                        v-model="item.linkCopied">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="copyLink(item)"
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="ims-action"
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  style="color:#fff"
                                  small
                                >mdi-content-copy</v-icon>
                              </template>
                              <span>Copy Travel Form</span>
                            </v-tooltip>
                          </v-btn>
                        </template>
                        <span><v-icon color="white darken-2">mdi-check-all</v-icon> Copied</span>
                      </v-tooltip>
                      <!-- Assign company -->
                      <!-- Reset Password User -->
                      <v-btn
                        @click="openResetDialog(item)"
                        color="secondary"
                        class="ims-action"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              style="color:#fff"
                            >mdi-pencil-lock</v-icon>
                          </template>
                          <span>Reset Password</span>
                        </v-tooltip>
                      </v-btn>
                      
                      <!-- View IG -->
                      <v-btn @click="showReport(item, 'instagram')" color="info" class="ims-action" v-show="item.igHandle">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <i class="fab fa-instagram" v-on="on"></i>
                          </template>
                          <span>View Instagram Audience</span>
                        </v-tooltip>
                      </v-btn>
                      <!-- View TikTok -->
                      <v-btn @click="showReport(item, 'tiktok')" color="info" class="ims-action" v-show="item.tiktokHandle">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <img src="/static/img/tik-tok-white.png" width="20px" v-on="on" />
                          </template>
                          <span>View TikTok Audience</span>
                        </v-tooltip>
                      </v-btn>
                      <!-- View Youtube -->
                      <v-btn @click="showReport(item, 'youtube')" color="info" class="ims-action" v-show="item.youtubeHandle">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-youtube</v-icon>
                          </template>
                          <span>View Youtube Audience</span>
                        </v-tooltip>
                      </v-btn>
                      <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            medium
                            v-if="buttonShow('assignCompany')"
                            v-on="on"
                            color="success"
                            @click.stop="getCompanyDataToView(item)"
                          >how_to_reg</v-icon>
                        </template>
                        <span>Assign Company</span>
                      </v-tooltip> -->
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <input type="hidden" id="copy-reportlink" :value="reportLink">
        </v-col>
      </v-row>      
    </section>

    <!-- CreateInfluencer modal -->
    <create-influencer-modal :modalId="createModalId" @createInfluencer="createInfluencer" />

    <!-- EditInfluencer modal -->
    <!-- <edit-influencer-modal
      :modalId="editModalId"
      :influencerData="editInfluencerData"
      @editInfluencer="editInfluencer"
      v-model="editInfluencerDialog"
    /> -->

    <!-- ViewInfluencer modal -->
    <view-influencer-modal v-model="viewInfluencerDialog" :influencerData="viewInfluencerData" />

    <!-- Audience data report modal -->
    <audience-data-report-modal
      v-model="viewAudienceDataDialog"
      :audienceData="audienceDataReport"
      :handle="viewAudHandle"
      :platform="viewAudPlatform"
      @showLoadingEvent="showLoadingEvent"
    />

    <!-- ViewInfluencerCompanies modal -->
    <view-influencer-company-modal
      :modalId="viewCompanyModalId"
      :influencerData="viewInfluencerData_company"
    />

    <!-- View Influencer post -->
    <influencer-post-modal
      :modalId="influencerPostModalId"
      :title="postsTitle"
      :shortCodes="shortCodes"
    />

    <!-- view inf platforms modal -->
    <inf-platforms-view-modal
      :platforms="viewPlatforms"
      :influencerID="selectedInfluencerID"    
      :influencer="viewInfluencerData"
      v-model="infPlatformsDialog"
      @reload="paginate(currentPage)"
    />

    <!-- inf user password reset modal -->
    <inf-reset-password-modal
      :influencerID="selectedInfluencerID"
      :influencer="viewInfluencerData"
      v-model="infPassResetDialog"
      @reload="paginate(currentPage)"
    />

    <v-dialog
      v-model="showLoading"      
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text style="padding-top:10px;">
          Exporting your data.
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
import moment from 'moment';
import config from '@/config';
import influencerAPIs from './influencerAPIs';
import userAPIs from '../User/userAPIs';
import pairingAPIs from '../Pairing/pairingAPIs';
import PostAPIs from '../Post/postApi';
import CreateInfluencerModal from './CreateInfluencerModal';
import EditInfluencerModal from './EditInfluencerModal';
import ViewInfluencerModal from './ViewInfluencerModal';
import AudienceDataReportModal from './AudienceDataReportModal';
import InfluencerPostModal from './InfluencerPostsModal';
import ViewInfluencerCompanyModal from './ViewInfluencerCompanyModal';
import InfPlatformsViewModal from './InfPlatforms/ViewModal.vue';
import InfResetPasswordModal from '../User/InfResetPasswordModal.vue';
import influencerHelper from './influencerHelper'
import Loading from 'vue-loading-overlay';
import utils from '../../../utils';
import uniq from 'lodash/uniq';

export default {
  name: 'influencer',
  components: {
    CreateInfluencerModal,
    EditInfluencerModal,
    ViewInfluencerModal,
    AudienceDataReportModal,
    InfluencerPostModal,
    ViewInfluencerCompanyModal,
    InfPlatformsViewModal,
    InfResetPasswordModal,
    Loading
  },
  data() {
    return {
      viewInfluencerDialog: false,
      editInfluencerDialog: false,
      viewAudienceDataDialog: false,
      infPassResetDialog: false,
      viewAudHandle: '',
      viewAudPlatform: '',
      createModalId: 'create_influencer_modal',
      editModalId: 'edit_influencer_modal',
      viewCompanyModalId: 'view_influencer_company_modal',
      influencerPostModalId: 'influencerPostModalId',
      editInfluencerData: null,
      viewInfluencerData: null,
      audienceDataReport: null,
      viewInfluencerData_company: null,
      sortBy: 'name',
      influencerGeos: [], // new filter influencer
      infCategories: influencerHelper.getCategories(),
      infCategory: [],
      search: null,
      expand: false, // Close other rows
      shouldCallApi: false,
      loading: false,
      isLoading: false,
      pagination: {
        // v-data-table pagination
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: ['audienceCredibility'],
        itemsPerPage: 20
      },
      totalItems: 0,
      rowsPerPageItems: [10, 20, 50, 100, { text: 'All', value: -1 }],
      postsTitle: '',
      avatarSize: 30, // avatar
      countries: [], // For filter influencer
      shortCodes: [],
      sortDesc: false,
      platforms: ['Instagram', 'Facebook'],
      selectedPlatform: 'instagram',
      platformList: [
        {
          text: 'Instagram',
          value: 'instagram'
        },
        {
          text: 'TikTok',
          value: 'tiktok'
        },
        {
          text: 'Youtube',
          value: 'youtube'
        },
        {
          text: 'Xiaohongshu',
          value: 'xiaohongshu'
        },
        {
          text: 'Facebook',
          value: 'facebook'
        },
        {
          text: 'LinkedIn',
          value: 'linkedin'
        },
        {
          text: 'X (Twitter)',
          value: 'twitter'
        }
      ],
      platformFilterOptions: [
        { text: 'Instagram', filterKey: 'hasIG', icon: 'mdi-instagram', iconColor: '#E4405F' },
        { text: 'TikTok', filterKey: 'hasTikTok', imgIcon: '/static/img/tiktok-32.png' },
        { text: 'YouTube', filterKey: 'hasYoutube', icon: 'mdi-youtube', iconColor: '#ff0000' },
        { text: 'XHS', filterKey: 'hasXHS', imgIcon: '/static/img/xhs-black.png' },
        { text: 'Facebook', filterKey: 'hasFb', icon: 'mdi-facebook', iconColor: '#1877f2' },
        { text: 'LinkedIn', filterKey: 'hasLinkedIn', icon: 'mdi-linkedin', iconColor: '#0a66c2' },
        { text: 'X (Twitter)', filterKey: 'hasTwitter', imgIcon: '/static/img/x-logo.svg' }
      ],
      viewPlatforms: [],
      selectedInfluencerID: '',
      searchInfID: '',
      fields: [
        {
          value: 'fullName',
          text: 'Full Name',
          sortable: false
        },
        {
          value: 'email',
          text: 'Email',
          sortable: false
        },
        {
          value: 'igHandle',
          text: 'Instagram Handle',
          sortable: false
        },
        {
          value: 'tiktokHandle',
          text: 'TikTok Handle',
          sortable: false
        },
        {
          value: 'youtubeHandle',
          text: 'Youtube Handle',
          sortable: false
        },
        {
          value: 'fbHandle',
          text: 'FB Handle',
          sortable: false
        },
        {
          value: 'xhsHandle',
          text: 'XHS Handle',
          sortable: false
        },
        {
          value: 'linkedinHandle',
          text: 'LinkedIn Handle',
          sortable: false
        },
        {
          value: 'twitterHandle',
          text: 'X (Twitter) Handle',
          sortable: false
        },
        // {
        //   value: 'totalFollowers',
        //   text: 'Followers',
        //   sortable: false
        // },
        // {
        //   value: 'engagementRate',
        //   text: 'Engagement Rate',
        //   sortable: false
        // },
        // {
        //   value: 'audienceCredibility',
        //   text: 'Audience Credibility',
        //   sortable: false
        // },
        {
          value: 'joinedAt',
          text: 'Joint At',
          sortable: false
        },
        {
          value: 'lastLoginAt',
          text: 'Last Login At',
          sortable: false
        },
        {
          value: 'action',
          text: 'Actions'
        }
      ],
      // Setting search influencer by keyword
      negativeKeyword: '',
      negativePeriod: 'entire_account',
      optInOnly: false,
      searchDuration: 12,
      searchNlu: true,
      computerVison: true,
      dialog: false,
      items: [],
      users: [],
      searchFilter: {
        hasIG: false,
        hasTikTok: false,
        hasYoutube: false,
        hasXHS: false,
        hasFb: false,
        hasLinkedIn: false,
        hasTwitter: false,
        pendingApproval: false
      },
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      keyword: '',
      fromAge: '',
      toAge: '',
      fromFol: '',
      toFol: '',
      fromEng: '',
      toEng: '',
      filGender: 'Any',
      igHandle: '',
      searchedItems: [],
      selectedCountries: ['all'],
      resultMessage: '',
      joinedMonth: '',
      monthPicker: false,
      showLoading: false,
      infPlatformsDialog: false,
      reportLink: '',
      linkCopied: false
    };
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    updatedOn: function() {
      return moment(this.lastUpdate).fromNow();
    },
    createModalIdDisplay: function() {
      return '#' + this.createModalId;
    },
    editModalIdDisplay: function() {
      return '#' + this.editModalId;
    },
    viewCompanyModalIdDisplay: function() {
      return '#' + this.viewCompanyModalId;
    },
    influencerPostDisplay: function() {
      return '#' + this.influencerPostModalId;
    },
    availableCountries() {
      // extract the available countries
      return uniq(this.searchedItems.map(item => item.country));
    },
    payload() {
      return {
        filter: {
          geo: this.influencerGeos,
          audience_geo: null,
          igHandle: this.igHandle,
          joinedMonth: this.joinedMonth,
          platform: this.selectedPlatform,
          influencerID: this.searchInfID,
          hasIG: this.searchFilter.hasIG,
          hasTikTok: this.searchFilter.hasTikTok,
          hasYoutube: this.searchFilter.hasYoutube,
          hasXHS: this.searchFilter.hasXHS,
          hasFb: this.searchFilter.hasFb,
          hasLinkedIn: this.searchFilter.hasLinkedIn,
          hasTwitter: this.searchFilter.hasTwitter,
          pendingApproval: this.searchFilter.pendingApproval
        },
        paging: {
          per_page: this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage,
          page: 1,
          sortBy: this.pagination.sortBy[0],
          descending: this.pagination.sortDesc[0]
        }
      };
    }
  },
  watch: {
    pagination(newVal) {
      if (this.shouldCallApi) {
        this.paginate(newVal.page);
      }
    }
  },
  methods: {
    togglePlatformFilter(filterKey) {
      this.$set(this.searchFilter, filterKey, !this.searchFilter[filterKey]);
      this.paginate();
    },
    buttonShow(type) {
      const roleAllow = config['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    getCountries() {
      influencerAPIs.getCountries().then(countries => {
        this.countries = countries.map(item => item.name);
      });
    },
    updateItems(response) {
      const displayItems = response.influencers.map(element => {
        let item = {
          id: element._id || element.id,
          instagramID: element.instagram ? element.instagram.instagramID : null,
          instagramFullname: element.fullName || (element.instagram ? element.instagram.instagramFullname : null),
          tiktokID: element.tiktok ? element.tiktok.tiktokID : null,
          tiktokFullname: element.fullName || (element.tiktok ? element.tiktok.tiktokFullname : null),
          youtubeID: element.youtube ? element.youtube.youtubeID : null,
          youtubeFullname: element.fullName || (element.youtube ? element.youtube.youtubeFullname : null),
          xhsID: element.xiaohongshu ? element.xiaohongshu.xhsID : null,
          xhsFullname: element.xiaohongshu ? element.xiaohongshu.xhsFullname : null,
          fbID: element.facebook ? element.facebook.facebookId : null,
          fbFullname: element.facebook ? element.facebook.name : null,
          linkedinFullname: element.linkedin ? element.linkedin.linkedinFullname : null,
          fullName: element.fullName,
          email: element.email,
          joinedAt: this.formatTime(element.createdAt),
          posts: element.posts || [],
          audience: element.audience || {},
          tiktokaudience: element.tiktokaudience || {},
          youtubeaudience: element.youtubeaudience || {},
          instagram: element.instagram || {},
          tiktok: element.tiktok || null,
          youtube: element.youtube || null,
          xiaohongshu: element.xiaohongshu || null,
          facebook: element.facebook || null,
          linkedin: element.linkedin || null,
          twitter: element.twitter || null,
          gender: element.gender,
          birthday: element.birthday || 'None',
          keywords: element.keywords,
          mailingAddress: element.mailingAddress || 'None',
          bankAccount: element.bankAccount || 'None',
          bankName: element.bankName || 'None',
          swiftCode: element.swiftCode || '',
          country: element.country || 'None',
          relevancyScore: element.relevancyScore ? Number(element.relevancyScore).toFixed(2) : 0,
          tallySub: element.tallySub || {},
          lastLoginAt: element.lastLoginAt || ''
        }
        if (element.tiktok) {
          // item.platform = 'tiktok'
          item.tiktokHandle = element.tiktok ? element.tiktok.tiktokHandle : null
          item.tiktokProfilePicture = element.tiktokaudience && element.tiktokaudience.user_profile ? element.tiktokaudience.user_profile.picture : '/static/img/avatar/user.png'
          item.tiktokTotalFollowers = element.tiktok ? element.tiktok.totalFollowers : 0
          item.tiktokTotalFollowing = element.tiktok ? element.tiktok.totalFollowing : 0
          item.engagementRate = element.tiktokaudience && element.tiktokaudience.user_profile
          ? (Number(element.tiktokaudience.user_profile.engagement_rate) * 100).toFixed(2)
          : 0
          item.audienceCredibility = 'N/A'
        }
        if (element.youtube) {
          // item.platform = 'youtube'
          item.youtubeHandle = element.youtube ? element.youtube.youtubeHandle : null
          item.youtubeProfilePicture = element.youtubeaudience && element.youtubeaudience.user_profile ? element.youtubeaudience.user_profile.picture : '/static/img/avatar/user.png'
          item.youtubeTotalFollowers = element.youtube ? element.youtube.totalFollowers : 0
          item.youtubeTotalFollowing = element.youtube ? element.youtube.totalFollowing : 0
          item.engagementRate = element.youtubeaudience && element.youtubeaudience.user_profile
          ? (Number(element.youtubeaudience.user_profile.engagement_rate) * 100).toFixed(2)
          : 0
          item.audienceCredibility = 'N/A'
        }
        if (element.facebook) {
          item.fbHandle = element.facebook ? element.facebook.handle : null
          item.fbProfilePicture = element.facebook ? element.facebook.profilePicture : '/static/img/avatar/user.png'
          item.fbTotalFollowers = element.facebook ? element.facebook.totalFollowers : 0
          item.fbTotalFollowing = element.facebook ? element.facebook.totalFollowing : 0
          item.engagementRate = ''
          item.audienceCredibility = 'N/A'
          if (!item.fullName) {
            item.fullName = element.facebook ? element.facebook.name : ''
          }
        }
        if (element.xiaohongshu) {
          item.xhsHandle = element.xiaohongshu ? element.xiaohongshu.xhsHandle : null
          item.xhsFullname = element.xiaohongshu ? element.xiaohongshu.xhsFullname : ''
          item.xhsID = element.xiaohongshu ? element.xiaohongshu.xhsID : ''
          item.xhsProfilePicture = element.xiaohongshu ? element.xiaohongshu.profilePicture : '/static/img/avatar/user.png'
          item.xhsTotalFollowers = element.xiaohongshu ? element.xiaohongshu.totalFollowers : 0
          item.xhsTotalFollowing = element.xiaohongshu ? element.xiaohongshu.totalFollowing : 0
          item.engagementRate = ''
          item.audienceCredibility = 'N/A'
          if (!item.fullName) {
            item.fullName = element.xiaohongshu ? element.xiaohongshu.xhsFullname : ''
          }
        }
        if (element.linkedin) {
          item.linkedinHandle = element.linkedin.linkedinHandle || null
          item.linkedinProfilePicture = '/static/img/avatar/user.png'
          item.linkedinTotalFollowers = element.linkedin.totalFollowers || 0
          item.engagementRate = ''
          item.audienceCredibility = 'N/A'
          if (!item.fullName) {
            item.fullName = element.linkedin.linkedinFullname || ''
          }
        }
        if (element.twitter) {
          item.twitterHandle = element.twitter.twitterHandle || null
          item.twitterProfilePicture = '/static/img/avatar/user.png'
          item.twitterTotalFollowers = element.twitter.totalFollowers || 0
          item.twitterTotalFollowing = element.twitter.totalFollowing || 0
          item.engagementRate = ''
          item.audienceCredibility = 'N/A'
          if (!item.fullName) item.fullName = element.twitter.twitterFullname || ''
        }
        if (element.instagram) {
          // item.platform = 'instagram'
          item.igHandle = element.instagram ? element.instagram.instagramHandle : null
          item.igProfilePicture = element.audience && element.audience.user_profile ? element.audience.user_profile.picture : '/static/img/avatar/user.png'
          item.totalFollowers = element.instagram ? element.instagram.totalFollowers : 0
          item.totalFollowing = element.instagram ? element.instagram.totalFollowing : 0
          item.engagementRate = element.audience && element.audience.user_profile
              ? (Number(element.audience.user_profile.engagement_rate) * 100).toFixed(2)
              : 0
          item.audienceCredibility = element.audience && element.audience.audience_followers && element.audience.audience_followers.success
              ? Number(element.audience.audience_followers.data.audience_credibility * 100).toFixed(2)
              : 0
        }
        return item
      });
      this.items = displayItems;
      this.totalRows = response.totalInfluencers;
      // store the searched results for Filtering
      this.searchedItems = displayItems;
    },
    paginate(page = 1) {
      this.currentPage = page;
      this.payload.paging.page = page;
      this.loading = true;
      this.shouldCallApi = false;
      influencerAPIs
        .paginate(this.payload)
        .then(response => {
          this.updateItems(response);
          this.pagination.data = response.influencers
          this.resultMessage = `Showing [` + this.perPage + `] per page of total [` + this.totalRows + `] influencers result.`;
          this.totalItems = this.totalRows;
          if (this.pagination.itemsPerPage === -1) {
            this.pagination.itemsPerPage = 20;
          }
          this.loading = false;
          setTimeout(() => {
            this.shouldCallApi = true;
          }, 1000)
          if (this.$route.query.id) {
            this.getInfluencerDataToView(this.$route.query.id, null)
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    createInfluencer(influencerData) {
      // Reload table + cache with the latest data
      this.getAllInfluencers(true);
    },
    async deleteInfluencer(influencerID) {
      let matchInf = this.items.find(item => item.id === influencerID);
      if (matchInf) {
        let searchInfluencers = []
        if (matchInf.igHandle) {
          searchInfluencers.push({
            handle: matchInf.igHandle,
            platform: 'instagram',
            influencerID: matchInf.id
          })
        }
        if (matchInf.tiktokHandle) {
          searchInfluencers.push({
            handle: matchInf.tiktokHandle,
            platform: 'tiktok',
            influencerID: matchInf.id
          })
        }
        if (matchInf.youtubeHandle) {
          searchInfluencers.push({
            handle: matchInf.youtubeHandle,
            platform: 'youtube',
            influencerID: matchInf.id
          })
        }
        if (matchInf.fbHandle) {
          searchInfluencers.push({
            handle: matchInf.fbHandle,
            platform: 'facebook',
            influencerID: matchInf.id
          })
        }
        this.isLoading = true
        let posts = await PostAPIs.getPostsByInfluencers(searchInfluencers)
        let pairings = []
        for (let inf of searchInfluencers) {
          let resp = await pairingAPIs.getPairingsByInfluencerID(inf.influencerID)
          if (resp) {
            let respIDs = resp.map(r => r.id)
            let isPairingExists = pairings.find(p => respIDs.includes(p.id))
            if (!isPairingExists) {
              pairings.push(...resp)
            }
          }
        }
        matchInf.totalPosts = posts.length
        matchInf.totalPairings = pairings.length
      }
      this.isLoading = false
      let htmlTxt = 'Are you sure you want to delete this influencer? This action cannot be undone.<br>';
      htmlTxt += `Total Posts: ${matchInf.totalPosts}<br>`
      htmlTxt += `Total Pairings: ${matchInf.totalPairings}`
      this.$swal({
        title: 'Double Check!',
        html: htmlTxt,
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.loading = true
          influencerAPIs
            .deleteInfluencer(influencerID)
            .then(response => {
              this.items = this.items.filter(influencer => influencer.id !== influencerID);
            })
            .catch(error => {
              // Request failed.
              this.loading = false
              console.log('error', error);
            });
          this.loading = false
        }
      })
    },
    getInfluencerDataToEdit(influencerID) {
      influencerAPIs
        .getInfluencer(influencerID)
        .then(response => {
          if (response) {
            let influencerUserData = this.users.find(u => u.influencerID === response.id)
            if (influencerUserData) {
              response.userID = influencerUserData.id || ''
              response.firstName = influencerUserData.firstName || ''
              response.lastName = influencerUserData.lastName || ''
            }
            this.editInfluencerData = response;
            this.editInfluencerDialog = true;
          }
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    getInfluencerDataToView(influencerID, infItem) {
      influencerAPIs
        .getInfluencer(influencerID)
        .then(response => {
          let influencerUserData = this.users.find(u => u.influencerID === response.id)
          if (influencerUserData) {
            response.userID = influencerUserData.id || ''
            response.firstName = influencerUserData.firstName || ''
            response.lastName = influencerUserData.lastName || ''
            // The user profile owns the creator's primary platform. Keep it
            // on the view payload so edit mode does not show metrics for
            // secondary accounts that are merely bound to the creator.
            response.platform = influencerUserData.platform || response.platform || ''
          }
          if (response.facebook) {
            // set fb object
            let matchFb = this.items.find(i => i.facebook && i.facebook.id === response.facebook.id)
            if (matchFb) response.facebook = matchFb.facebook
          }
          if (response.xiaohongshuID) {
            // set xhs object
            let matchXHS = this.items.find(i => i.xiaohongshu && i.xiaohongshu.id === response.xiaohongshuID)
            if (matchXHS) response.xiaohongshu = matchXHS
          }
          if (infItem) {
            if (infItem.tallySub) {
              response.tallySub = infItem.tallySub
              delete response.tallySub._id
              delete response.tallySub.influencerID
            }
          }
          this.viewInfluencerData = response;
          this.viewInfluencerDialog = true;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    viewInfluencerPosts(item) {
      let posts = item.posts || [];
      if (posts.length > 0) {
        this.shortCodes = posts.map(item => item.shortCode);
        document.getElementById('viewPosts').click();
        this.postsTitle = `Related Posts(${item.instagramHandle})`;
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },

    paserImageUrl(url) {
      if (!url) return '/static/img/avatar/user.png';
      var newUrl = url
        .replace('http://imgp.socapi.icu/', location.origin + '/socapi')
        .replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },

    showReport(influencer, platform) {
      this.isLoading = true
      this.viewAudHandle = ''
      this.viewAudPlatform = ''
      this.audienceDataReport = null
      let audID = null
      let handle = null
      if (platform === 'tiktok') {
        audID = influencer.tiktokaudience ? influencer.tiktokaudience.id : null
        handle = influencer.tiktokHandle
      } else if (platform === 'youtube') {
        audID = influencer.youtubeaudience ? influencer.youtubeaudience.id : null
        handle = influencer.youtubeHandle
      } else {
        audID = influencer.audience ? influencer.audience.id : null
        handle = influencer.igHandle
      }
      influencerAPIs
        .fetchLocalAudienceReportByAudID(audID, handle, platform)
        .then(resp => {
          this.audienceDataReport = resp.data;
          this.viewAudienceDataDialog = true;
          this.viewAudHandle = handle
          this.viewAudPlatform = platform
          this.isLoading = false
        })
        .catch(err => {
          this.viewAudienceDataDialog = true;
          this.isLoading = false
          console.error(err);
        });
    },

    getCompanyDataToView(influencerData) {
      this.viewInfluencerData_company = influencerData;
      document.getElementById('viewCompany').click();
    },
    getPlatformDataToView(influencerData) {
      influencerAPIs
        .getInfluencer(influencerData.id)
        .then(response => {
          this.viewPlatforms = utils.func.refreshJSON(this.platformList)
          this.selectedInfluencerID = influencerData.id
          this.viewInfluencerData = response
          this.viewPlatforms = this.viewPlatforms.map(p => {
            const platformData = response[p.value] || influencerData[p.value]
            if (platformData && platformData.id) {
              p.connected = true
              p.requested = false
              switch (p.value) {
                case 'tiktok':
                  p.handle = platformData.tiktokHandle
                  break;
                case 'youtube':
                  p.handle = platformData.youtubeHandle
                  break;
                case 'xiaohongshu':
                  p.handle = platformData.xhsHandle
                  break;
                case 'facebook':
                  p.handle = platformData.handle
                  break;
                case 'linkedin':
                  p.handle = platformData.linkedinHandle
                  break;
                case 'twitter':
                  p.handle = this.normalizeTwitterHandle(platformData.twitterHandle)
                  break;
                default:
                  p.handle = platformData.instagramHandle
                  break;
              }
            }
            if ((!response.instagram || !response.instagram.instagramHandle) && p.value === 'instagram' && response.reqIgHandle) {
              // for connect req from inf
              p.handle = response.reqIgHandle
              p.connected = false
              p.requested = true
            }
            if ((!response.tiktok || !response.tiktok.tiktokHandle) && p.value === 'tiktok' && response.reqTikTokHandle) {
              // for connect req from inf
              p.handle = response.reqTikTokHandle
              p.connected = false
              p.requested = true
            }
            if ((!response.youtube || !response.youtube.youtubeHandle) && p.value === 'youtube' && response.reqYoutubeHandle) {
              // for connect req from inf
              p.handle = response.reqYoutubeHandle
              p.connected = false
              p.requested = true
            }
            if (!p.connected && p.value === 'linkedin' && response.reqLinkedinHandle) {
              // for LinkedIn connect request from influencer
              p.handle = response.reqLinkedinHandle
              p.connected = false
              p.requested = true
            }
            return p
          })
          this.infPlatformsDialog = true;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    normalizeTwitterHandle(value) {
      let handle = String(value || '').trim()
      const twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i)
      if (twitterUrl) handle = twitterUrl[1]
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    },
    editInfluencer(influencerData) {
      // Update the edited content to user
      var selectedIndex = -1;

      this.items.forEach(function(influencer, index) {
        if (influencer.id === influencerData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, influencerData);
      }

      // Do anything like highlighting the edited item
      console.log('influencer edited');
      this.getUsers()
    },
    exportInfluencers() {
      // influencerAPIs
      //   .exportAllInfluencers()
      //   .then(response => {
      //     const url = window.URL.createObjectURL(new Blob([response]));
      //     const link = document.createElement('a');
      //     link.href = url;
      //     link.setAttribute('download', `influencers_${moment().format('X')}.csv`);
      //     document.body.appendChild(link);
      //     link.click();
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
      // let data = {
      //   'influencers': this.pagination.data
      // }
      this.showLoading = true
      influencerAPIs
        .exportInfluencersByFilter(this.payload)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `influencers_${moment().format('X')}.csv`);
          document.body.appendChild(link);
          link.click();
          this.showLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.showLoading = false;
        });
    },
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatDateTime(value) {
      return moment(value).format('MMM DD, YYYY hh:mm:ss');
    },
    // Filter the result
    filterItems() {
      // iniitalize default values if the value is null
      let minAge = !this.fromAge ? 0 : this.fromAge;
      let maxAge = !this.toAge ? 150 : this.toAge;
      let minFol = !this.fromFol ? 0 : this.fromFol;
      let maxFol = !this.toFol ? 1000000000 : this.toFol;
      let minEng = !this.fromEng ? 0 : this.fromEng;
      let maxEng = !this.toEng ? 100 : this.toEng;
      let gender = this.filGender === 2 ? 'both' : this.filGender;
      let handle = this.igHandle;
      let countries = this.selectedCountries;

      let filteredItems = [];
      this.searchedItems.forEach(function(item, index) {
        // calculate the age
        let today = moment().format('YYYY');
        let bd = moment(item.birthday).format('YYYY');
        let age = today - bd;

        // handle the multiple country selection
        let countryStatus = false;
        countries.map(cnty => {
          if (cnty === item.country || cnty === 'all') {
            countryStatus = true;
          }
        });

        // for each match cases
        if (
          minAge <= age &&
          maxAge >= age &&
          minFol <= item.totalFollowers && maxFol >= item.totalFollowers &&
          minEng <= item.engagementRate && maxEng >= item.engagementRate &&
          (gender === item.gender || gender === 'both') &&
          countryStatus &&
          item.instagramHandle &&
          (item.instagramHandle.includes(handle) || handle === '')
        ) {
          filteredItems.push(item);
        }
      });
      // put the filtered results into the table
      this.items = filteredItems;
      this.resultMessage = `Showing (Filtered Influencers) based on your searched results.`;
    },
    resetFilters() {
      // reset into initial state for filters
      this.fromAge = '';
      this.toAge = '';
      this.fromFol = '';
      this.toFol = '';
      this.fromEng = '';
      this.toEng = '';
      this.filGender = 'Any';
      this.igHandle = '';
      this.influencerGeos = [];
      this.paginate(this.currentPage);
    },
    reloadAll() {
      // reset to default
      this.currentPage = 1;
      this.perPage = 15;
      this.keyword = '';
      this.igHandle = '';
      this.joinedMonth = '';
      this.searchInfID = ''
      this.resetFilters();
    },
    remove(item) {
      this.influencerGeos.splice(this.influencerGeos.indexOf(item), 1);
      this.influencerGeos = [...this.influencerGeos];
      this.paginate(this.currentPage)
    },
    removeCategory(item) {
      this.infCategory.splice(this.infCategory.indexOf(item), 1);
      this.infCategory = [...this.infCategory];
    },
    joinedMonthOk() {
      this.$refs.monthPicker.save(this.joinedMonth)
      this.paginate(this.currentPage)
    },
    async getUsers() {
      // Get all Influencers User Data by role
      let response = await userAPIs.getAllUsersByRole(config.userRoles.INFLUENCER)
      if (response) {
        this.users = response.users
      }
    },
    showLoadingEvent(status) {
      this.isLoading = status
    },
    copyLink(item) {
      const protocol = window.location.protocol
      const host = window.location.host
      let vm = this;
      if (item) {
        this.reportLink = `${protocol}//${host}/creators/travel?`
        if (item.tiktokHandle) this.reportLink += `tiktokHandle=${item.tiktokHandle}&`
        if (item.igHandle) this.reportLink += `igHandle=${item.igHandle}&`
        this.reportLink += `influencerID=${item.id}&`
        setTimeout(function() { item.linkCopied = utils.func.copyToClipboard('#copy-reportlink') }, 100)
        setTimeout(function() { item.linkCopied = false }, 1000)
      } else {
        this.reportLink = `${protocol}//${host}/creators/travel`
        setTimeout(function() { vm.linkCopied = utils.func.copyToClipboard('#copy-reportlink') }, 100)
        setTimeout(function() { vm.linkCopied = false }, 1000)
      }
    },
    openResetDialog(item) {
      if (!item.email) {
        this.$swal({
          title: 'Empty Email',
          text: 'Please update email to reset password.',
          type: 'warning'
        })
        return
      }
      this.viewInfluencerData = item
      this.infPassResetDialog = true
    }
  },
  created() {
    if (this.$route.query.id) {
      this.searchInfID = this.$route.query.id
    }
    this.paginate(this.currentPage);
    this.getCountries();
    this.userGender_options = config.userGenderDisplay;
    this.getUsers()
  }
};
</script>

<style>
#ig-handle {
  cursor: pointer;
}
.engagement {
  color: #81bee2;
  font-size: 20px;
}
.search-keyword-wrapper {
  padding-right: 2px;
}
nav hr {
  margin-top: 0px !important;
}
.ims-action {
  margin: 6px 1px !important;
  min-width: 35px !important;
  padding: 0px !important;
}
.pending-approval-checkbox .v-label {
  font-weight: 500!important;
}
.platform-filter {
  align-items: center;
  background: #f7f8fa;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 12px;
}
.platform-filter__label {
  color: #475467;
  font-size: 13px;
  font-weight: 600;
  margin-right: 4px;
}
.platform-filter__button {
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 9px;
  color: #344054!important;
  letter-spacing: 0!important;
  min-height: 34px;
  text-transform: none;
}
.platform-filter__button--active {
  background: #fff4fb!important;
  border-color: #d82d8b;
  color: #9f145f!important;
}
.platform-filter__logo {
  height: 18px;
  margin-right: 8px;
  object-fit: contain;
  width: 18px;
}
@media (max-width: 600px) {
  .platform-filter__label {
    flex-basis: 100%;
  }
  .platform-filter__button {
    flex: 1 1 calc(50% - 8px);
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7c77d3f5